import React, { memo } from "react";
import {
    RiAddLine,
} from "@remixicon/react";
import useCreateTicket from "../../../../contexts/CreateTicketContext";
import Button from "../../../theme/button/Button";

function CreateTicketRequest({ metricPathPrefix }: { metricPathPrefix: string[] }) {
    const createTicket = useCreateTicket();

    return (
        <Button
            metricPath={[...metricPathPrefix, "ticket", "create"]}
            size="small"
            prefixIcon={<RiAddLine />}
            onClick={() => createTicket.show()}
        >
            New Request
        </Button>
    );
}

export default memo(CreateTicketRequest);
